
import { computed, defineComponent, PropType } from "vue";
import { IAttributeGroup } from "@/services/Models";
import { v4 as uuid } from "uuid";

export default defineComponent({
  name: "SelectAttributeLine",
  props: {
    attributeGroup: { type: Object as PropType<IAttributeGroup> },
    selectedAttributeIDs: { type: Object as PropType<number[]> },
  },
  setup(props, context) {
    const selectedList = computed({
      get: () => props.selectedAttributeIDs,
      set: (newValue) => context.emit("update:selectedAttributeIDs", newValue),
    });
    const isNotSelected = computed({
      get: () => (props.selectedAttributeIDs ?? []).length == 0,
      set: (newValue: boolean) => {
        if (newValue) {
          context.emit("update:selectedAttributeIDs", []);
        }
      },
    });
    const uuidValue = uuid().toString();
    return {
      uuidValue,
      isNotSelected,
      selectedList,
    };
  },
});
